// Studyo Today Backend
// Package studyo.today.item_duplication.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/item_duplication/v1/resources/cycle_day_item_repetition.proto (package studyo.today.item_duplication.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/item_duplication/v1/resources/cycle_day_item_repetition.proto.
 */
export const file_studyo_today_item_duplication_v1_resources_cycle_day_item_repetition = /*@__PURE__*/
  fileDesc("CkpzdHVkeW8vdG9kYXkvaXRlbV9kdXBsaWNhdGlvbi92MS9yZXNvdXJjZXMvY3ljbGVfZGF5X2l0ZW1fcmVwZXRpdGlvbi5wcm90bxIqc3R1ZHlvLnRvZGF5Lml0ZW1fZHVwbGljYXRpb24udjEucmVzb3VyY2VzIiwKFkN5Y2xlRGF5SXRlbVJlcGV0aXRpb24SEgoKY3ljbGVfZGF5cxgBIAMoBUIxqgIuU3R1ZHlvLlRvZGF5Lkl0ZW1EdXBsaWNhdGlvbi5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z");

/**
 * Describes the message studyo.today.item_duplication.v1.resources.CycleDayItemRepetition.
 * Use `create(CycleDayItemRepetitionSchema)` to create a new message.
 */
export const CycleDayItemRepetitionSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_item_duplication_v1_resources_cycle_day_item_repetition, 0);

